// types
export const CLEAR_MESSAGES = "CLEAR_MESSAGES";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";

export enum MessageType {
  "INFO",
  "ERROR",
  "SUCCESS",
  "WARNING",
  "WAREHOUSE",
}

export enum RestockReason {
  "CANCELLATION",
  "PARTIAL_DELIVERY",
}

export type ResponseMessageType =
  | MessageType.INFO
  | MessageType.ERROR
  | MessageType.SUCCESS
  | MessageType.WARNING
  | MessageType.WAREHOUSE;

export interface IResponseMessage {
  messageType: ResponseMessageType;
  title: string;
  content: string;
  serverMessageId?: number;
}
export interface IResponseMessageUI extends IResponseMessage {
  createdAt: string;
  id: number | string;
}

// actions
export interface ClearMessageAction {
  type: typeof CLEAR_MESSAGES;
}

export interface RemoveMessageAction {
  type: typeof REMOVE_MESSAGE;
  payload: number | string | IResponseMessageUI;
}
export interface AddMessageAction {
  type: typeof ADD_MESSAGE;
  payload: IResponseMessage;
}
export const clearMessages = () => ({
  type: CLEAR_MESSAGES,
});

export const removeMessage = (messageOrId: number | string | IResponseMessageUI) => ({
  type: REMOVE_MESSAGE,
  payload: messageOrId,
});

export const addMessage = (message: IResponseMessage) => ({
  type: ADD_MESSAGE,
  payload: message,
});

const initialState: IResponseMessageUI[] = [];

const responseMessagesReducer = (
  state = initialState,
  action: ClearMessageAction | RemoveMessageAction | AddMessageAction
) => {
  switch (action.type) {
    case CLEAR_MESSAGES:
      return [];
    case REMOVE_MESSAGE: {
      const messageId = typeof action.payload === "object" ? action.payload.id : action.payload;
      return state.filter((message) => message.id !== messageId);
    }
    case ADD_MESSAGE:
      const message: IResponseMessageUI = {
        ...action.payload,
        id: action.payload.serverMessageId ?? Math.random().toString(36).substr(2, 9),
        createdAt: new Date().toLocaleString("sv-SE", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }),
      };
      return [...state, message];
    default:
      return state;
  }
};

export default responseMessagesReducer;
